let lockCount = 0;

export function lockScrollPage(status = true) {
  const html = document.documentElement;

  if (status) {
    if (lockCount === 0) {
      html.classList.add('is-locked');
    }
    lockCount++;
  } else {
    lockCount = Math.max(0, lockCount - 1);

    if (lockCount === 0) {
      html.classList.remove('is-locked');
    }
  }
}
